"use strict";

var take = require("./take.js");

const take1 = take(1);
module.exports = take1;